var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":_vm.errors.length > 0,"variant":"danger"}},_vm._l((_vm.errors),function(item){return _c('p',{key:item},[_vm._v(_vm._s(item))])}),0),(
      _vm.loadedResultInquiry != null &&
      (_vm.loadedResultInquiry.usertype === 1 ||
        _vm.loadedResultInquiry.usertype === 2)
    )?_c('EnamadReal',{attrs:{"submitted":_vm.submitted},on:{"validattion":_vm.validattion}}):_c('EnamadLegal',{attrs:{"submitted":_vm.submitted},on:{"validattion":_vm.validattion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }